import { render, staticRenderFns } from "./TopDataUsers.vue?vue&type=template&id=4ae57e04&"
import script from "./TopDataUsers.vue?vue&type=script&lang=js&"
export * from "./TopDataUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports